import UTM from './utm'
import Cookies from './cookies'
import { capitalize, formatCurrency, formatDate } from './filters'
import { throttle, debounce } from './timers'

export {
	UTM,
	Cookies,
	debounce,
	throttle,
	capitalize,
	formatDate,
	formatCurrency
}

export const trimSpaces = (name) => {
	return name.replace(/\s+/g, ' ').trim()
}

const s4 = () => {
	return Math.floor((1 + Math.random()) * 0x10000)
		.toString(16)
		.substring(1)
}

export const uniqueKey = () => {
	return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`
}

export const fileToBase64 = (file) => {
	return new Promise((resolve) => {
		const reader = new FileReader()

		// Read file content on file loaded event
		reader.onload = function (event) {
			resolve(event.target.result)
		}

		// Convert data to base64
		reader.readAsDataURL(file)
	})
}

export const objectKeyValuesSwap = (json) => {
	const ret = {}

	// eslint-disable-next-line guard-for-in
	for (const key in json) {
		ret[json[key]] = key
	}

	return ret
}

export const openChatbot = (message, user) => {
	const chatBot = document.getElementById('zsiq_float')
	const chatBotIframe = document.getElementById('siqiframe')

	chatBot && chatBot.click()

	if (chatBotIframe) {
		const inputName = chatBotIframe.contentWindow.document.getElementById('visname')
		const inputEmail = chatBotIframe.contentWindow.document.getElementById('visemail')
		const inputPhone = chatBotIframe.contentWindow.document.getElementById('visphone')
		const inputMessage = chatBotIframe.contentWindow.document.getElementById('msgarea')

		if (inputName && inputEmail && inputPhone && inputMessage) {
			inputName.value = (user && user.name) || ''
			inputEmail.value = (user && user.email) || ''
			inputPhone.value = (user && user.phone) || ''
			inputMessage.value = message || ''

			const event = document.createEvent('Event')

			event.initEvent('keyup', true, true)

			inputEmail.dispatchEvent(event)
			inputPhone.dispatchEvent(event)
			inputMessage.focus()
		}
	}
}

export const isSubtypeOf = (obj1, obj2) => {
	return Object.keys(obj2).every((obj2Key) => {
		return obj1[obj2Key] === obj2[obj2Key]
	})
}

export const setBodyClass = (className) => {
	document.body.className = `${className}`
}
